import styled from "styled-components";

export const Container = styled.div`
	background-color: var(--white);
	box-shadow: 0px 3px 3px 0px rgba(0, 0, 0, 0.1);
	position: sticky;
	top: 0;
	left: 0;
	z-index: 100;

	header.header {
		height: 60px;
		display: flex;
		align-items: center;
		justify-content: space-between;

		.logo img {
			display: inline-block;
			max-width: 140px;
			height: auto;
		}

		.nav {
			flex: 1 1 auto;
			padding-right: 2em;

			&__list {
				list-style: none;
				padding: 0;
				display: flex;
				justify-content: flex-end;

				.nav-item {
					& + .nav-item {
						margin-left: 2em;
					}

					a {
						font-size: 1.125em;
						text-decoration: none;
						border-bottom: 4px solid transparent;
						transition: all 0.5s;

						&:hover {
							border-color: #dbdcdd;
						}
					}
				}
			}
		}

		.menu-icons {
			display: flex;
			align-items: center;

			img.icon {
				height: 20px;
				cursor: pointer;
				margin-left: 1em;

				& + img.icon {
					margin-left: 30px;
				}
			}

			.link-profile {
				position: relative;

				p {
					font-size: 1.125em;
					cursor: pointer;
				}

				.menu-sigin {
					display: none;
					position: absolute;
					top: 30px;
					left: 50%;
					transform: translateX(-50%);
					list-style: none;
					padding: 10px 15px;
					background-color: var(--white);
					border: 1px solid #dbdcdd;

					&.show,
					&:hover {
						display: block;
					}

					li {
						& + li {
							border-top: 1px solid #dbdcdd;
						}

						a {
							text-decoration: none;
							font-size: 18px;
							line-height: 36px;
						}
					}
				}
			}
		}
	}

	.nav-mobile {
		position: absolute;
		top: 0;
		left: 0;
		background-color: rgba(0, 0, 0, 0.4);
		width: 100%;
		height: 100vh;
		z-index: 3000;

		.nav {
			position: absolute;
			min-width: 210px;
			top: 0;
			right: 0;
			background-color: var(--primary-color);
			height: 100%;

			.close-nav {
				position: absolute;
				right: 1em;
				top: 1em;
				background: none;
				border: none;
				outline: 0;

				svg {
					path {
						fill: var(--white);
					}
				}
			}

			hr {
				background-color: var(--white);
				border: 1px solid var(--white);
				margin-top: 2.5em;
			}

			&__list {
				list-style: none;
				padding-left: 2em;
				padding-right: 2em;
				margin-top: 2.5em;

				.nav-item {
					margin-bottom: 1em;

					&--spotligh {
						display: flex;
						justify-content: space-between;
						align-items: center;

						div {
							display: flex;
							justify-content: space-between;
							align-items: center;

							svg {
								width: 24px;
								height: auto;
								margin-right: 1em;
								g {
									stroke: var(--white);
								}
							}

							span {
								color: white;
								font-weight: 600;
								font-size: 1.2em;
							}
						}

						& > svg {
							transform: rotate(90deg);

							path {
								stroke: var(--white);
								stroke-width: 2px;
							}
						}
					}

					a {
						text-decoration: none;
						color: white;
						font-weight: 600;
						font-size: 1em;
					}
				}
			}
		}
	}
`;
